import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import bpsdm from '../assets/img/BPSDMhub.logo.png';
import '../styles/Regulasi.css';

const RegulasiInternal = () => {
  return (
    <>
      <Navbar />
      <div style={{ marginLeft: '50px', marginRight: '50px' }}>
        <header className="header-banner">
          <h2>REGULASI</h2>
        </header>

        <section className="kementerian-content">
          <div className="kementerian-card">
            <a href="https://bpsdm.kemenhub.go.id/sekolah-kedinasan" target="_blank" rel="noopener noreferrer">
              <img src={bpsdm} alt="Logo bpsdm" />
              <div className="info">
                <a href="https://bpsdm.dephub.go.id/sekolah-kedinasan" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'black', fontWeight: 'bold' }}>
                  BADAN PENGEMBANGAN SUMBER DAYA MANUSIA PERHUBUNGAN
                </a>
                <p>Jl. Medan Merdeka Timur No.5, RT.2/RW.1 Gambir, Jakarta Pusat DKI Jakarta 10110</p>
                <p>Telp: (021) 3847519</p>
                <p>Email: <a href="mailto:humasti-bpsdmp@dephub.go.id">humasti-bpsdmp@dephub.go.id</a></p>
                <p>Website: <a href="https://bpsdm.kemenhub.go.id">bpsdm.kemenhub.go.id</a></p>
              </div>
            </a>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default RegulasiInternal;
